import api from './api';

const runQuery = async ({ name, start, stop, window, filter }) => {
  const client = await api.getClient();
  const result =  await api.handleSuccess(await client.MonitoringFetch(null, { name, start, stop, window, filter }));
  return result;
}


export default {
  runQuery
}
